import { tv } from 'tailwind-variants'

export const layoutVariants = tv({
  slots: {
    container: 'flex flex-col items-center w-full h-full'
  }
})
